import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import Items from "@/views/Items.vue";
import Categories from "@/views/Categories.vue";
import { getToken } from "@/api/client";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", component: Login },
    {
      path: "/",
      component: Home,
      children: [
        { path: "", redirect: "items" },
        { path: "items", component: Items },
        { path: "categories", component: Categories },
      ],
      meta: { requiresAuth: true },
    },
    { path: "*", redirect: "/" },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth)) {
    // if (!getToken()) return next("/login");
  }
  next();
});

export default router;